import {getPlatform} from './getPlatform';
import {isMobileDevice} from './isMobileDevice';
import {rowCenterSpcBtwWrap} from './rowCenterSpcBtwWrap';
import {validateEmail, validatePassword} from './validateEmail';

import scrollToTop from './scrollToTop';

import getTabs from './getTabs';
import rowSpcBtw from './rowSpcBtw';
import rowCenter from './rowCenter';
import flexCenter from './flexCenter';
import columnCenter from './columnCenter';
import numberOfLines from './numberOfLines';
import rowCenterWrap from './rowCenterWrap';
import rowCenterSpcBtw from './rowCenterSpcBtw';
import rowWrapSpcBtween from './rowWrapSpcBtween';
import rowCenterFlexEnd from './rowCenterFlexEnd';
import rowCenterSpcAround from './rowCenterSpcAround';
import columnCenterSpcBtween from './columnCenterSpcBtween';
import {downloadFile} from './downloadFile';

export const utils = {
  getTabs,
  rowCenter,
  flexCenter,
  rowSpcBtw,
  scrollToTop,
  getPlatform,
  columnCenter,
  numberOfLines,
  rowCenterWrap,
  isMobileDevice,
  validateEmail,
  rowWrapSpcBtween,
  rowCenterFlexEnd,
  rowCenterSpcBtw,
  rowCenterSpcAround,
  validatePassword,
  rowCenterSpcBtwWrap,
  columnCenterSpcBtween,
  downloadFile,
};
